module.exports = __webpack_public_path__ + "static/media/darkSetting.37e456d9.svg";